import React from "react";
import Box from "@mui/material/Box";
import Avatar from '@mui/material/Avatar';

/** Root-relative URL; `public/logo.png` is copied to dist by webpack (no CRA `PUBLIC_URL` / DefinePlugin here). */
const logoSrc = "/logo.png";

export const AppName = "AdaptPrepare"

export const LogoSmallScreen = (
    <Box
        component="img"
        src={logoSrc}
        alt=""
        sx={{
            display: { xs: "block", md: "block", lg: "none" },
            mr: 1,
            height: 50,
            width: "auto",
            objectFit: "contain",
        }}
    />
);
export const LogoLargeScreen = (
    <Box
        component="img"
        src={logoSrc}
        alt=""
        sx={{
            display: { xs: "none", md: "none", lg: "block" },
            mr: 1,
            height: 55,
            width: "auto",
            objectFit: "contain",
        }}
    />
);


export const GoldMedal1 = (<svg height="200px" width="200px" version="1.1" id="Layer_1"
    viewBox="0 0 300.439 300.439">
    <g>
        <path style={{ "fill": "#BF392C" }} d="M276.967,0h-84.498L70.415,178.385h84.498L276.967,0z" />
        <path style={{ "fill": "#E2574C" }} d="M23.472,0h84.498l122.053,178.385h-84.498L23.472,0z" />
        <path style={{ "fill": "#EFC75E" }} d="M154.914,93.887c57.271,0,103.276,46.005,103.276,103.276s-46.005,103.276-103.276,103.276
S51.638,254.434,51.638,197.163S97.643,93.887,154.914,93.887z"/>
        <path style={{ "fill": "#D7B354" }} d="M154.914,122.053c-41.31,0-75.11,33.799-75.11,75.11s33.799,75.11,75.11,75.11
s75.11-33.799,75.11-75.11S196.224,122.053,154.914,122.053z M154.914,253.495c-30.983,0-56.332-25.35-56.332-56.332
s25.35-56.332,56.332-56.332s56.332,25.35,56.332,56.332S185.896,253.495,154.914,253.495z"/>
    </g>
</svg>)

export const GoldMedal = (
    <svg width="100px" height="120px" version="1.1" id="Layer_1" viewBox="0 100 200 150">
  

  <path d="M50 60 Q75 110 100 155 Q85 80 85 60 Z" style={{"fill":"url(#blueRibbon)"}}/>
  <path d="M150 60 Q125 110 100 155 Q115 80 115 60 Z" style={{"fill":"url(#redRibbon)"}}/>

  <ellipse cx="100" cy="265" rx="50" ry="12" style={{"fill":"rgba(0,0,0,0.2)"}} filter="url(#softShadow)"/>

  <circle cx="100" cy="200" r="60" style={{"fill":"url(#goldGradient)"}} stroke="#DAA520" stroke-width="4" filter="url(#outerGlow)"/>

  <ellipse cx="90" cy="185" rx="35" ry="15" style={{"fill":"white"}} opacity="0.3" transform="rotate(-20 90 185)"/>
  <ellipse cx="110" cy="175" rx="20" ry="8" style={{"fill":"white"}} opacity="0.2" transform="rotate(-20 110 175)"/>

  <circle cx="100" cy="200" r="45" style={{"fill":"rgba(255, 223, 0, 0.3)"}}/>
  <circle cx="100" cy="200" r="35" style={{"fill":"none"}} stroke="url(#ringGradient)" stroke-width="2" stroke-dasharray="5,5"/>
  <circle cx="100" cy="200" r="25" style={{"fill":"none"}} stroke="url(#ringGradient)" stroke-width="1" stroke-dasharray="2,4"/>

  <polygon points="100,175 107,190 123,190 110,200 115,215 100,207 85,215 90,200 77,190 93,190" style={{"fill":"#FFF8DC"}} stroke="#FFD700" stroke-width="2"/>
  <defs>
    <linearGradient id="goldGradient" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0%" stop-color="#FFD700"/>
      <stop offset="50%" stop-color="#FFA500"/>
      <stop offset="100%" stop-color="#FFD700"/>
    </linearGradient>
    <linearGradient id="ringGradient" x1="0" y1="0" x2="1" y2="1">
      <stop offset="0%" stop-color="#FFF4B0"/>
      <stop offset="100%" stop-color="#FFD700"/>
    </linearGradient>
    <linearGradient id="hookShine" x1="0" y1="0" x2="1" y2="1">
      <stop offset="0%" stop-color="#FFF4C1"/>
      <stop offset="40%" stop-color="#FFD700"/>
      <stop offset="100%" stop-color="#B8860B"/>
    </linearGradient>
    <linearGradient id="blueRibbon" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0%" stop-color="#1E90FF"/>
      <stop offset="100%" stop-color="#104E8B"/>
    </linearGradient>
    <linearGradient id="redRibbon" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0%" stop-color="#FF0000"/>
      <stop offset="100%" stop-color="#8B0000"/>
    </linearGradient>
    <filter id="outerGlow" x="-50%" y="-50%" width="200%" height="200%">
      <feGaussianBlur in="SourceGraphic" stdDeviation="8" result="blur"/>
      <feMerge>
        <feMergeNode in="blur"/>
        <feMergeNode in="SourceGraphic"/>
      </feMerge>
    </filter>
    <filter id="softShadow" x="-50%" y="-50%" width="200%" height="200%">
      <feGaussianBlur in="SourceAlpha" stdDeviation="4" result="blur"/>
      <feOffset dx="0" dy="3" result="offsetBlur"/>
      <feMerge>
        <feMergeNode in="offsetBlur"/>
        <feMergeNode in="SourceGraphic"/>
      </feMerge>
    </filter>
  </defs>
</svg>
)

export const SilverMedal = (
  <svg width="100px" height="120px" version="1.1" id="Layer_1" viewBox="0 100 200 150">
  <defs>
    <linearGradient id="silverGradient" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0%" stop-color="#E0E0E0"/>
      <stop offset="50%" stop-color="#C0C0C0"/>
      <stop offset="100%" stop-color="#A0A0A0"/>
    </linearGradient>
    <linearGradient id="ringGradient" x1="0" y1="0" x2="1" y2="1">
      <stop offset="0%" stop-color="#F5F5F5"/>
      <stop offset="100%" stop-color="#C0C0C0"/>
    </linearGradient>
    <linearGradient id="hookShine" x1="0" y1="0" x2="1" y2="1">
      <stop offset="0%" stop-color="#F0F0F0"/>
      <stop offset="40%" stop-color="#D3D3D3"/>
      <stop offset="100%" stop-color="#A9A9A9"/>
    </linearGradient>
    <linearGradient id="blueRibbon" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0%" stop-color="#1E90FF"/>
      <stop offset="100%" stop-color="#104E8B"/>
    </linearGradient>
    <linearGradient id="redRibbon" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0%" stop-color="#FF0000"/>
      <stop offset="100%" stop-color="#8B0000"/>
    </linearGradient>
    <filter id="outerGlow" x="-50%" y="-50%" width="200%" height="200%">
      <feGaussianBlur in="SourceGraphic" stdDeviation="8" result="blur"/>
      <feMerge>
        <feMergeNode in="blur"/>
        <feMergeNode in="SourceGraphic"/>
      </feMerge>
    </filter>
    <filter id="softShadow" x="-50%" y="-50%" width="200%" height="200%">
      <feGaussianBlur in="SourceAlpha" stdDeviation="4" result="blur"/>
      <feOffset dx="0" dy="3" result="offsetBlur"/>
      <feMerge>
        <feMergeNode in="offsetBlur"/>
        <feMergeNode in="SourceGraphic"/>
      </feMerge>
    </filter>
  </defs>

  <path d="M50 60 Q75 110 100 155 Q85 80 85 60 Z" fill="url(#blueRibbon)"/>
  <path d="M150 60 Q125 110 100 155 Q115 80 115 60 Z" fill="url(#redRibbon)"/>

  <ellipse cx="100" cy="265" rx="50" ry="12" style={{"fill":"rgba(0,0,0,0.2)"}} filter="url(#softShadow)"/>


  <circle cx="100" cy="200" r="60" style={{"fill":"url(#silverGradient)"}} stroke="#A9A9A9" stroke-width="4" filter="url(#outerGlow)"/>


  <ellipse cx="90" cy="185" rx="35" ry="15" style={{"fill":"white"}} opacity="0.3" transform="rotate(-20 90 185)"/>
  <ellipse cx="110" cy="175" rx="20" ry="8" style={{"fill":"white"}} opacity="0.2" transform="rotate(-20 110 175)"/>


  <circle cx="100" cy="200" r="45" style={{"fill":"rgba(230, 230, 230, 0.3)"}}/>
  <circle cx="100" cy="200" r="35" style={{"fill":"none"}} stroke="url(#ringGradient)" stroke-width="2" stroke-dasharray="5,5"/>
  <circle cx="100" cy="200" r="25" style={{"fill":"none"}} stroke="url(#ringGradient)" stroke-width="1" stroke-dasharray="2,4"/>

  <polygon points="100,175 107,190 123,190 110,200 115,215 100,207 85,215 90,200 77,190 93,190" style={{"fill":"#F8F8F8"}} stroke="#C0C0C0" stroke-width="2"/>
</svg>

)
export const SilverMedal1 = (<svg height="200px" width="200px" version="1.1" id="Layer_1"
    viewBox="0 0 300.439 300.439">
    <g>
        <path style={{ "fill": "#BF392C" }} d="M276.967,0h-84.498L70.415,178.385h84.498L276.967,0z" />
        <path style={{ "fill": "#E2574C" }} d="M23.472,0h84.498l122.053,178.385h-84.498L23.472,0z" />
        <path style={{ "fill": "#E4E7E7" }} d="M154.914,93.887c57.271,0,103.276,46.005,103.276,103.276s-46.005,103.276-103.276,103.276
S51.638,254.434,51.638,197.163S97.643,93.887,154.914,93.887z"/>
        <path style={{ "fill": "#CDCFCF" }} d="M154.914,122.053c-41.31,0-75.11,33.799-75.11,75.11s33.799,75.11,75.11,75.11
s75.11-33.799,75.11-75.11S196.224,122.053,154.914,122.053z M154.914,253.495c-30.983,0-56.332-25.35-56.332-56.332
s25.35-56.332,56.332-56.332s56.332,25.35,56.332,56.332S185.896,253.495,154.914,253.495z"/>
    </g>
</svg>)

export const BronzeMedal = (
  <svg width="100px" height="120px" version="1.1" id="Layer_1" viewBox="0 100 200 150">
  <defs>
    <radialGradient id="bronzeGlow" cx="50%" cy="50%" r="50%">
      <stop offset="0%" stop-color="rgba(255, 215, 150, 0.5)"/>
      <stop offset="100%" stop-color="rgba(205, 127, 50, 0)"/>
    </radialGradient>
    <linearGradient id="bronzeGradient" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0%" stop-color="#CD7F32"/>
      <stop offset="50%" stop-color="#B87333"/>
      <stop offset="100%" stop-color="#8C5A2B"/>
    </linearGradient>
    <linearGradient id="ringGradient" x1="0" y1="0" x2="1" y2="1">
      <stop offset="0%" stop-color="#FFD2A1"/>
      <stop offset="100%" stop-color="#A05A2C"/>
    </linearGradient>
    <linearGradient id="hookShine" x1="0" y1="0" x2="1" y2="1">
      <stop offset="0%" stop-color="#E2BFA3"/>
      <stop offset="40%" stop-color="#B87333"/>
      <stop offset="100%" stop-color="#8C5A2B"/>
    </linearGradient>
    <linearGradient id="blueRibbon" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0%" stop-color="#1E90FF"/>
      <stop offset="100%" stop-color="#104E8B"/>
    </linearGradient>
    <linearGradient id="redRibbon" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0%" stop-color="#FF0000"/>
      <stop offset="100%" stop-color="#8B0000"/>
    </linearGradient>
    <filter id="outerGlow" x="-50%" y="-50%" width="200%" height="200%">
      <feGaussianBlur in="SourceGraphic" stdDeviation="8" result="blur"/>
      <feMerge>
        <feMergeNode in="blur"/>
        <feMergeNode in="SourceGraphic"/>
      </feMerge>
    </filter>
    <filter id="softShadow" x="-50%" y="-50%" width="200%" height="200%">
      <feGaussianBlur in="SourceAlpha" stdDeviation="4" result="blur"/>
      <feOffset dx="0" dy="3" result="offsetBlur"/>
      <feMerge>
        <feMergeNode in="offsetBlur"/>
        <feMergeNode in="SourceGraphic"/>
      </feMerge>
    </filter>
  </defs>

  <path d="M50 60 Q75 110 100 155 Q85 80 85 60 Z" fill="url(#blueRibbon)"/>
  <path d="M150 60 Q125 110 100 155 Q115 80 115 60 Z" fill="url(#redRibbon)"/>

  <ellipse cx="100" cy="265" rx="50" ry="12" style={{"fill":"rgba(0,0,0,0.2)"}} filter="url(#softShadow)"/>

  <circle cx="100" cy="200" r="70" style={{"fill":"url(#bronzeGlow)"}}/>

  <circle cx="100" cy="200" r="60" style={{"fill":"url(#bronzeGradient)"}} stroke="#8C5A2B" stroke-width="4" filter="url(#outerGlow)"/>

  <ellipse cx="90" cy="185" rx="35" ry="15" style={{"fill":"white"}} opacity="0.3" transform="rotate(-20 90 185)"/>
  <ellipse cx="110" cy="175" rx="20" ry="8" style={{"fill":"white"}} opacity="0.2" transform="rotate(-20 110 175)"/>

  <circle cx="100" cy="200" r="45" style={{"fill":"rgba(205, 127, 50, 0.25)"}}/>
  <circle cx="100" cy="200" r="35" style={{"fill":"none"}} stroke="url(#ringGradient)" stroke-width="2" stroke-dasharray="5,5"/>
  <circle cx="100" cy="200" r="25" style={{"fill":"none"}} stroke="url(#ringGradient)" stroke-width="1" stroke-dasharray="2,4"/>

  <polygon points="100,175 107,190 123,190 110,200 115,215 100,207 85,215 90,200 77,190 93,190" style={{"fill":"#FFD7A1"}} stroke="#A05A2C" stroke-width="2"/>
</svg>
)

export const BronzeMedal1 = (<svg height="200px" width="200px" version="1.1" id="Layer_1"
    viewBox="0 0 300.439 300.439">
    <g>
        <path style={{ "fill": "#BF392C" }} d="M276.967,0h-84.498L70.415,178.385h84.498L276.967,0z" />
        <path style={{ "fill": "#E2574C" }} d="M23.472,0h84.498l122.053,178.385h-84.498L23.472,0z" />
        <path style={{ "fill": "#ED9D5D" }} d="M154.914,93.887c57.271,0,103.276,46.005,103.276,103.276s-46.005,103.276-103.276,103.276
S51.638,254.434,51.638,197.163S97.643,93.887,154.914,93.887z"/>
        <path style={{ "fill": "#D58D54" }} d="M154.914,122.053c-41.31,0-75.11,33.799-75.11,75.11s33.799,75.11,75.11,75.11
s75.11-33.799,75.11-75.11S196.224,122.053,154.914,122.053z M154.914,253.495c-30.983,0-56.332-25.35-56.332-56.332
s25.35-56.332,56.332-56.332s56.332,25.35,56.332,56.332S185.896,253.495,154.914,253.495z"/>
    </g>
</svg>)